import { DayOfWeek } from "@/types/enums.type";
import { OfficeDto, OfficeHourDto, OfficeProfileDto } from "@/types/office.type";
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("OfficeProfile", [
      "selectedOffice",
      "officeProfiles",
      "errorMessage",
      "isEdit",
      "pageLoading"
    ])
  }
})
export default class OfficeProfileMixin extends Vue {
  selectedOffice!: OfficeDto | null;
  officeProfiles!: OfficeProfileDto[];
  errorMessage!: string;
  isEdit!: boolean;
  pageLoading!: boolean;

  getOpenTime(day: DayOfWeek, hours: OfficeHourDto[]): string | null {
    const officeHour = hours.filter(x => x.dayOfWeek == day)[0];
    return !officeHour.openTime ? null : officeHour.openTime;
  }

  getCloseTime(day: DayOfWeek, hours: OfficeHourDto[]): string | null {
    const officeHour = hours.filter(x => x.dayOfWeek == day)[0];
    return !officeHour.closeTime ? null : officeHour.closeTime;
  }

  getBreakMinutes(day: DayOfWeek, hours: OfficeHourDto[]): string | null {
    const officeHour = hours.filter(x => x.dayOfWeek == day)[0];
    return !officeHour.breakMinutes ? null : officeHour.breakMinutes;
  }

  setLoading(value: boolean): void {
    this.$store.commit("OfficeProfile/updateField", {
      path: "pageLoading",
      value: value
    });
  }
}